import { all, call, put, takeEvery } from "redux-saga/effects";
import { pushNotification } from "utils/notifications";
import { geDecryptPayload } from "../services/apis/collections/oAuthApis";

import {
  uploadMedia,
  searchMedia,
  getVisit,
  getStaff,
  uploadCSV,
  getUsersAggregateList,
  getDecryptedPayload,
  getGPSHistoricalData,
  acceptTwilioReservation,
  rejectTwilioReservation,
  completeTwilioReservation,
  getTwilioUserStatus,
  updateTwilioUserStatus,
  saveTwilioRecording,
  holdTwilioCall,
  addTwilioParticipant,
  saveOutgoingRecording,
  invokeWorkflow
} from "../services/apis/collections/oAuthApis";

import {
  UPLOAD_MEDIA,
  UPLOAD_CSV,
  GET_VISIT,
  GET_STAFF,
  SET_URL_PARAMS,
  GET_MAP_PLACES,
  GET_CALL_LOGS,
  GET_AGGREGATE,
  GET_TICKET_PAGES,
  DECRYPT_TOKEN,
  GET_HISTORICAL_GPS,
  ACCEPT_RESERVATION,
  REJECT_RESERVATION,
  COMPLETE_TASK,
  GET_USER_STATUS,
  UPDATE_USER_STATUS,
  SAVE_RECORDING,
  HOLD_CALL,
  ADD_PARTICIPANT,
  RECORD_OUTGOING,
  INVOKE_WORKFLOW
} from "reducers/reducer";





function* uploadMediaAPI(action: { payload: any }) {
  try {
    const response = yield call(uploadMedia, action.payload.form);
    if (response && response.data) {
      const searchMediumRequest = {
        objectId: response.data.mediumId,
        paths: ["$"],
        returnPaths: ["$"],
      };
      const searchResponse = yield call(searchMedia, searchMediumRequest);

      console.log("search medium request", searchResponse);
      yield put({
        type: "ADD_FILE",
        payload: { id: action.payload.id, media: searchResponse.data[0][0] },
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getVisitAPI(action: { payload: any }) {
  try {
    const response = yield call(getVisit, action.payload.visitId);
    console.log("test here", response?.meta_data?.visit);
    yield put({ type: "SET_VISIT", payload: response?.meta_data?.visit });
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getStaffAPI(action: { payload: any }) {
  try {
    const response = yield call(getStaff, action.payload.staff);
    console.log('staff response', response);
    yield put({ type: "SET_STAFF", payload: response });
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* setUrlParamsAPI(action: { payload: any }) {
  try {
    const response = yield call(geDecryptPayload, { data: action.payload });
    const urlParams: any = {};
    if (response.status) {
      const { decryptedPayload } = response.data;
      const urlParamsStr = new URLSearchParams(decryptedPayload);

      const entries = urlParamsStr.entries();
      for (const entry of entries) {
        urlParams[entry[0]] = entry[1];
        console.log(`${entry[0]}: ${entry[1]}`);
      }
      yield put({ type: SET_URL_PARAMS, payload: urlParams });
    } else {
      pushNotification(
        "There is something wrong with the url",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error: any) {
    pushNotification(
      "There is something wrong with the url",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}

function* GetMapPlacesFilterDataAPI(action) {
  try {
    const { objectType } = action.payload;
    const response = yield call(getUsersAggregateList, {
      data: action.payload,
    });
    if (response && response.data) {
      let responseData;
      if (objectType === "user") {
        responseData = response.data
          ?.filter((user) => {
            return user.email || user.phone;
          })
          ?.map((user) => {
            return {
              id: user.objectIds.toString(),
              name: user?.profile?.firstName + " " + user.profile?.lastName,
              firstName: user?.profile?.firstName ?? "",
              lastName: user?.profile?.lastName ?? "",
              gender: user?.profile?.gender ?? "",
              dob: user?.profile?.dob ?? "",
              email: user.email,
              phone: user.phone,
              beamId: `${user?.profile?.firstName?.toLowerCase()}.${user?.profile?.lastName?.toLowerCase()}`,
              objectType,
              location: user?.profile?.location?.coordinates
                ? {
                    coordinates: [
                      user?.profile?.location.coordinates.long,
                      user?.profile?.location.coordinates.lat,
                    ],
                  }
                : undefined,
            };
          });
      } else if (objectType === "asset") {
        responseData = response.data.map((place) => ({
          id: place.objectId.toString(),
          name: place?.persistent?.static?.fixedAsset?.location?.attributes?.title,
          objectType,
          location: place?.persistent?.static?.fixedAsset?.location?.coordinates
            ? {
                coordinates: [
                  place?.persistent?.static?.fixedAsset?.location.coordinates.long,
                  place?.persistent?.static?.fixedAsset?.location.coordinates.lat,
                ],
              }
            : undefined,
        }));
      }
      console.log("response", responseData);
      yield put({
        type: `ADD_MAP_${action.payload.objectType.toUpperCase()}_FILTER`,
        payload: responseData || [],
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* GetAggregateDataAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(getUsersAggregateList, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* uploadCSVAPI(action: { payload: any }) {
  try {
    const response = yield call(uploadCSV, action.payload.form);
    pushNotification(
      "CSV uploaded successfully",
      "success",
      "TOP_CENTER",
      1000
    );
    yield put({ type: "ADD_CSV", payload: Date.now() });
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* decryptTokenAPI(action: { payload: any }) {
  try {
    console.log('decrypt token')
    const response = yield call(getDecryptedPayload, action.payload.data);
    console.log(response);
    if (response && response.data) {
      if(action.payload.callback){
        action.payload.callback(response.data);
      }
      yield put({ type: "ADD_ENCRYPTED_TOKEN", payload: JSON.parse(response.data.decryptedPayload) });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* GetGPSHistoricalDataAPI(action) {
  try {
    const { requestData } = action.payload;
    const response = yield call(getGPSHistoricalData, requestData);
    if (response && response.status) {
      yield put({
        type: "ADD_GPS",
        payload: { response }
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* invokeWorkflowApi(action: any) {
  const {request, callback} = action.payload;
  try {
    const response = yield call(invokeWorkflow, request);
    console.log("invoke", response);
    callback && callback(response);
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* AcceptTwilioReservationAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(acceptTwilioReservation, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* RejectTwilioReservationAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(rejectTwilioReservation, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* CompleteTwilioReservationAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(completeTwilioReservation, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    }
    //  else {
    //   pushNotification(response, "error", "TOP_CENTER", 1000);
    // }
  } catch (error: any) {
    console.log(error);
    // pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* GetTwilioUserStatusAPI(action) {
  try {
    console.log('get user srarys', action.payload)
    const { callback, requestData } = action.payload;
    const response = yield call(getTwilioUserStatus, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* UpdateTwilioUserStatusAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(updateTwilioUserStatus, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* SaveTwilioRecordingsAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(saveTwilioRecording, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* HoldTwilioCallAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(holdTwilioCall, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* AddTwilioParticipantAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(addTwilioParticipant, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* SaveOutgoingRecordingAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(saveOutgoingRecording, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* watchGetRequest() {
  yield takeEvery(UPLOAD_MEDIA, uploadMediaAPI);
  yield takeEvery(UPLOAD_CSV, uploadCSVAPI);
  yield takeEvery(GET_VISIT, getVisitAPI);
  yield takeEvery(GET_STAFF, getStaffAPI);
  yield takeEvery(SET_URL_PARAMS, setUrlParamsAPI);
  yield takeEvery(GET_MAP_PLACES, GetMapPlacesFilterDataAPI);
  yield takeEvery(GET_CALL_LOGS, GetAggregateDataAPI);
  yield takeEvery(GET_AGGREGATE, GetAggregateDataAPI);
  yield takeEvery(ACCEPT_RESERVATION, AcceptTwilioReservationAPI);
  yield takeEvery(REJECT_RESERVATION, RejectTwilioReservationAPI);
  yield takeEvery(COMPLETE_TASK, CompleteTwilioReservationAPI);
  yield takeEvery(GET_USER_STATUS, GetTwilioUserStatusAPI);
  yield takeEvery(UPDATE_USER_STATUS, UpdateTwilioUserStatusAPI);
  yield takeEvery(SAVE_RECORDING, SaveTwilioRecordingsAPI);
  yield takeEvery(HOLD_CALL, HoldTwilioCallAPI);
  yield takeEvery(ADD_PARTICIPANT, AddTwilioParticipantAPI);
  yield takeEvery(RECORD_OUTGOING, SaveOutgoingRecordingAPI);
  yield takeEvery(INVOKE_WORKFLOW, invokeWorkflowApi);
  yield takeEvery(GET_TICKET_PAGES, GetAggregateDataAPI);
  yield takeEvery(DECRYPT_TOKEN, decryptTokenAPI);
  yield takeEvery(GET_HISTORICAL_GPS, GetGPSHistoricalDataAPI);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}